<div class="monitoring-state-button" (click)="forceRun.emit()">
    <fa-icon [ngClass]="'icon-' + runningStatus | lowercase" *ngIf="icon" [icon]="icon"></fa-icon>
    <em class="fa fa-spinner" *ngIf="hasLoader"></em>
    <span [ngClass]="runningStatus | lowercase">
        {{ message }}
    </span>
</div>
